import { AfterViewInit, Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { HistoricConsumptionsFormComponent } from '../historic-consumptions-form/historic-consumptions-form.component';

@Component({
  selector: '[app-historic-consumptions]',
  template: `
    <div class="d-flex">
      <div>
        <h5 class="mt-2">Consumo histórico</h5>
      </div>
      <div class="ms-auto">
        <button class="btn btn-outline-secondary btn-sm" (click)="addHistoricConsumption()">
        <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon> 
        Agregar consumo
      </button>
      </div>
    </div>
    <div class="d-flex mt-3" *ngIf="historics.length>0">
      <table class="table table-sm table-striped" style="font-size: 0.9em;">
        <thead>
          <th>Consumo lt.</th>
          <th class="text-center">Precio</th>
          <th class="text-center">Periodo</th>
          <th class="text-center">Total</th>
          <th></th>
        </thead>
        <tbody>
          <tr *ngFor="let historic of historics">
            <td style="vertical-align: middle;">{{historic.consumo_lt}}</td>
            <td style="vertical-align: middle;" class="text-center">{{historic.gas_price | currency: 'USD'}}</td>
            <td style="vertical-align: middle;" class="text-center">{{getFrecuency(historic.frecuency)}}</td>
            <td style="vertical-align: middle;" class="text-center">{{historic.amount | currency: 'USD'}}</td>
            <td class="text-end">
              <!-- button class="btn btn-outline-secondary btn-sm me-2" (click)="editHistoricConsumption(historic)">
                <fa-icon [icon]="icons.faDownload"></fa-icon>
              </!-->
              <button class="btn btn-outline-secondary btn-sm me-2" (click)="editHistoricConsumption(historic)">
                <fa-icon [icon]="icons.faEdit"></fa-icon>
              </button>
              <button class="btn btn-outline-danger btn-sm" (click)="deleteHistoricConsumption(historic)">
                <fa-icon [icon]="icons.faTrashAlt"></fa-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-historic-consumptions-form [consumption]="selectedConsumption" [unit]="unit" (updateDismiss)="updateDismissed()"></app-historic-consumptions-form>
  `,
  styleUrls: []
})
export class HistoricConsumptionsComponent implements AfterViewInit {
  @Input() unit: any;
  @Input() permissions: any;

  @ViewChild(HistoricConsumptionsFormComponent, { static: true}) historicConsumptionsForm !: HistoricConsumptionsFormComponent;

  historics: any[] = [];
  selectedConsumption: any;

  constructor(
    private store: SettlementsService,
    public icons: IconsService
  ) { }

  ngAfterViewInit(): void {
    this.loadHistoricConsumptions(this.unit);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['unit'] && changes['unit'].currentValue) {
      this.loadHistoricConsumptions(changes['unit'].currentValue);
    }
  }

  getFrecuency(frecuency: number) {    
    const period = this.historicConsumptionsForm.periodos.find((p: any) => p.id === frecuency);
    return period?.name;
  }

  loadHistoricConsumptions(unit: any) {
    if (!unit.id) return;
    this.store.getHistoricConsumption(unit.id).subscribe({
      next: (data: any) => {
        this.historics = data;
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  addHistoricConsumption() {
    const modalTemplate: any | undefined = this.historicConsumptionsForm;
    if (modalTemplate) {
      this.historicConsumptionsForm.openModal(modalTemplate['historicConsumptionsForm']);
    }
  }

  editHistoricConsumption(historic: any) {
    this.selectedConsumption = historic;
    const modalTemplate: any | undefined = this.historicConsumptionsForm;
    if (modalTemplate) {
      this.historicConsumptionsForm.openModal(modalTemplate['historicConsumptionsForm']);
    }
  }

  deleteHistoricConsumption(historic: any) {

    const confirmation = confirm('¿Está seguro de eliminar este consumo histórico?');

    if (confirmation) {
      this.store.destroyHistoricConsumption(historic.id).subscribe({
        next: (data: any) => {
          this.loadHistoricConsumptions(this.unit);
        },
        error: (err: any) => {
          console.log(err);
        }
      });
    } else {
      return;
    }
  }

  updateDismissed() {
    this.loadHistoricConsumptions(this.unit);
  }
}
